import { useEffect, useState } from "react";
import { Alert, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import utilityService from "@fuse/services/utilityService";
import adminService from "@fuse/services/adminService";
import { IPetModel } from "@fuse/models";
import AdminEditPetProfileForm from "./AdminEditPetProfileForm";

function AdminEditPetApp() {
    const { id } = useParams();
    const [allSpecies, setSpecies] = useState([]);
    const [pet, setPet] = useState<IPetModel | null>(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [opening, setOpening] = useState(true);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        let active = true;
        setPet(null); setError(""); setOpening(true);
        async function openPet() {
            try {
                if (!id) throw new Error();
                const [response, lookup] = await Promise.all([
                    adminService.getPetById(id), utilityService.getStaticData()
                ]) as any[];
                if (!response?.result?.id || !Array.isArray(lookup?.result?.species)) throw new Error();
                if (!active) return;
                const data = response.result;
                setSpecies(lookup.result.species);
                setPet({ ...data,
                    imageUrl: data.image ? `${process.env.VITE_APP_API_BASE_URL}Pet/pet-images/${data.image}` : data.imageUrl,
                    dob: data.dob ? new Date(data.dob) : null,
                    lastRabiesVaccine: data.lastRabiesVaccine ? new Date(data.lastRabiesVaccine) : null
                });
            } catch {
                if (active) setError("Unable to open this pet's profile. The pet may have been removed or the request failed. Retry or return to admin search.");
            } finally {
                if (active) setOpening(false);
            }
        }
        void openPet();
        return () => { active = false; };
    }, [id, attempt]);

    return <div className="w-full p-[10px]">
        {opening && <div role="status"><CircularProgress size={24} /><Typography>Opening pet profile…</Typography></div>}
        {error && <Stack spacing={2}>
            <Alert severity="error">{error}</Alert>
            <div><Button onClick={() => setAttempt(value => value + 1)}>Retry</Button>
                <Button component={Link} to="/admin-search">Back to admin search</Button></div>
        </Stack>}
        {!opening && !error && pet && <AdminEditPetProfileForm key={pet.id}
            pet={pet} allSpecies={allSpecies} id={id} loading={loading} setLoading={setLoading} />}
    </div>;
}

export default AdminEditPetApp;
